import { Trans } from '@lingui/macro';
import { FormattedMarkdown } from '@qover/react-intl';
import React from 'react';

export const messages = {
  question1: {
    details: (
      <FormattedMarkdown id="bike.missingData.question1.description.details" />
    ),
    summary: (
      <Trans
        id="bike.missingData.question1.description.summary"
        defaults="Beantwoord deze vraag met “ja” als er sprake is geweest van"
      />
    ),
    title: (
      <Trans
        id="bike.missingData.question1"
        defaults="Heeft u in de afgelopen vijf jaar een weigering of opzegging ontvangen van een fietsverzekeraar?"
      />
    ),
  },
  question2: {
    title: (
      <Trans
        id="bike.missingData.question2"
        defaults="Heeft u in de afgelopen 5 jaar schade geleden of veroorzaakt door een gebeurtenis die door de aangevraagde verzekering wordt gedekt?"
      />
    ),
  },
  question3: {
    details: <Trans id="bike.missingData.question3.description.details" />,
    summary: (
      <FormattedMarkdown id="bike.missingData.question3.description.summary" />
    ),
    title: (
      <Trans
        id="bike.missingData.question3"
        defaults="Heeft u in de afgelopen acht jaar een overtreding begaan waardoor u in aanraking bent geweest met politie en/of veroordeeld bent door justitie?"
      />
    ),
  },
};
